<template>
  <BaseFieldWrapper
    v-bind="{...$props, ...$attrs}"

    v-model="search"
    @focus="focus"

    :wrapperClass="['search-selector', {opened}]"

    v-slot="{vuelidateIns, value: inputValue, listeners, attrs}"
  >
    <span>
      <input ref="input"
        :value="inputValue"
        :class="[
          vuelidateIns && 'border-danger',
          {'not-loading': !loading, loading, notFromTable: !table, tableForm: table},
        ]"

        v-bind="attrs"
        v-on="listeners"
        :id="attrs.id"

        :data-uid="selected"

        type="search"
        class="form-control"
        autocomplete="off"

        @keydown="keydown"
      >
      <div v-if="opened"
        class="dropdown"
        :style="{maxHeight}"
      >
        <div class="before">
          <slot name="before" :close="close"></slot>
        </div>

        <template v-if="!infiniteScrolling">
          <transition-group
            @enter="enter"
            @leave="leave"
          >
            <div v-for="item in filteredList" :key="item[uid]" @click="select(item)">
              <slot
                v-bind="item"
              ></slot>
            </div>
          </transition-group>
        </template>
        <InfiniteScrolling v-else
          :searchMore="searchMore"
          :showEnd="showEnd"
        >
          <transition-group
            @enter="enter"
            @leave="leave"
          >
            <div v-for="item in filteredList" :key="item[uid]" @click="select(item)">
              <slot
                v-bind="item"
              ></slot>
            </div>
          </transition-group>
        </InfiniteScrolling>

        <div class="after">
          <slot name="after" :close="close"></slot>
        </div>
      </div>

      <span class="arrow" @click="focusOnInput">
        <span v-if="selected" class="close-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="currentColor" @click.stop="deactivate">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </span>
        <svg v-else-if="!loading" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
        <svg v-else class="rotate" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      </span>
    </span>
  </BaseFieldWrapper>
</template>

<script>

import BaseFieldWrapper, { props } from "./FormFieldWrapper.vue"
import InfiniteScrolling from "src/layout/InfiniteScrolling.vue"

import transitionFunctionConstructor from "src/mixins/transitionFunctionConstructor.js"

export default {
  mixins: [transitionFunctionConstructor()],
  name: "base-search-selector",
  components: {
    BaseFieldWrapper,
    InfiniteScrolling,
  },
  props: {
    ...props,

    endpoint: {
      type: String,
      required: true,
    },
    selectFirst: {
      type: Boolean,
      required: false,
    },
    titleField: {
      type: String,
      default: "name",
      required: false,
    },
    infiniteScrolling: {
      type: Boolean,
      required: false,
    },
    params: {
      type: Object,
      required: false,
    },
    maxHeight: {
      type: String,
      required: false,
    },
    getCurrentSearchStr: {
      type: Function,
      required: false,
    },
    closeAfterSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    getNameFromEndpoint: Boolean,
    getList: {
      type: Function,
      required: false,
    },
    saveOnLocalstorage: Boolean,
    table: Boolean,
    storageId: String,
    uid: {
      type: String,
      default: "uid",
    },
    filter: {
      type: Function,
      required: false,
    },
    initialSearchValue: String,
    searchParameter: String,
  },
  data() {
    return {
      search: "",
      selectedSearch: "",
      opened: false,
      loaded: false,
      selected: this.value || null,
      showEnd: false,
      loading: false,

      list: [],
    }
  },
  async created() {
    if (this.initialSearchValue) {
      this.selectedSearch = this.initialSearchValue
      this.search = this.initialSearchValue
    } else if (this.getNameFromEndpoint) {
      this.getSelectedItemNameFromEndpoint()
    } else {
      this.saveOnLocalstorage ? this.getInitalValueFromLocalStorage() : this.mapInitialValue()
    }
    
    if (this.selectFirst && !this.getNameFromEndpoint) {
      this.opened = false
      this.list = await this.request()

      this.list[0] && this.select(this.list[0])
    }
  },
  mounted() {
    window.addEventListener("click", this.checkPath)
  },
  beforeDestroy() {
    window.removeEventListener("click", this.checkPath)
  },
  methods: {
    keydown({ key }) {
      if (key === "Enter") {
        this.select(this.list[0])
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.$emit("enter")
          })
        })
      }
    },
    
    async getSelectedItemNameFromEndpoint() {
      if (!this.value) return;
      
      const data = (await this.axios.get(`${this.endpoint}/${this.value}`)).data

      this.selected = data[this.uid]
      this.selectedSearch = data[this.titleField]
      this.search = this.selectedSearch
    },
    deactivate() {
      requestAnimationFrame(() => {
        this.opened = false
        this.selected = undefined
        this.selectedSearch = ""
        this.search = ""
      })
    },
    async getInitalValueFromLocalStorage() {
      this.selectedSearch = localStorage.getItem(`${this.id}-selectedSearch-search`) || ""
      this.selected = localStorage.getItem(`${this.id}-selected-search`) || ""
    },
    focusOnInput() {
      this.$refs.input.focus()
    },
    async searchMore(page = 1) {
      const list = await this.request(page)
      this.list.push(...list)

      return list.length === 0
    },

    close() {
      this.opened = false
    },
    mapInitialValue(val = this.value) {
      if (val && val[this.titleField]) {
        this.selected = val[this.uid]
        this.selectedSearch = val[this.titleField]
        this.search = this.selectedSearch
      }
    },

    checkPath(evt) {
      if (this.loading) return;

      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      !found && this.blur()
    },
    blur() {
      if (!this.opened) return;
      this.opened = false
      if (this.selected) {
        this.search = this.selectedSearch
      } else {
        this.search = ""
      }
    },
    async focus() {
      this.opened = true
      this.list = await this.request()
    },

    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    },
    async request(page = 1) {
      try {
        this.loading = true
        const data = (await this.axios.get(this.endpoint, {
          params: {
            page,
            ...(this.params || {}),
            [this.searchParameter ? this.searchParameter : (this.titleField || "name")]: this.search,
          },
        })).data || {}
        this.loaded = true

        this.loading = false

        return this.getList
          ? this.getList(data.results || [])
          : data.results || []
      } catch (err) {
        this.$catchError(err)
        this.loading = false
        return []
      }
    },
    select(item) {
      this.selectedSearch = item[this.titleField]
      this.selected = item[this.uid]
      this.search = this.selectedSearch

      this.$emit("option-select", item)

      this.closeAfterSelect && this.$nextTick(() => {
        this.clearTimeout()
        this.opened = false
        this.list = []
      })
    },
  },
  computed: {
    filteredList() {
      const filter = this.filter
      return filter ? this.list.filter(filter) : this.list
    },

    selectedItem() {
      const uid = this.selected
      return uid && this.list.find(item => item[this.uid] === uid)
    },
  },
  watch: {
    selected(uid) {
      this.$emit("input", uid)

      const elementId = this.storageId
      if (elementId) {
        localStorage.setItem(`${this.id}-selectedSearch-search`, this.selectedSearch || "")
        localStorage.setItem(`${this.id}-selected-search`, this.selected || "")
      }
    },
    selectedItem(item) {
      this.$emit("select-item", item)
    },
    value(val) {
      this.getNameFromEndpoint
        ? this.getSelectedItemNameFromEndpoint()
        : this.mapInitialValue()
    },
    initialSearchValue(val) {
      this.search = val
      this.selectedSearch = val
    },

    opened(val) {
      this.$emit("set-opened", val)

      if (!val) {
        this.list = []
        this.clearTimeout()
      }
    },
    search(val) {
      this.clearTimeout()

      this.timeout = setTimeout(async () => {
        this.list = await this.request()

        this.showEnd = this.list.length >= 10
      }, 200)
    },
  },
}

</script>

<style scoped>

.close-icon {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 8;
  display: inline-block;
  background-color: white;
  color: #bebfc1;
  cursor: pointer;
}

@keyframes Rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.rotate {
  animation-name: Rotation;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-play-state: running;
}

.search-selector {
  position: relative;
}

.search-selector:hover, .search-selector.opened {
  z-index: 20;
}

.arrow {
  position: absolute;
  color: #9A9A9A;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 275px;
  cursor: pointer;
  overflow: auto;
  z-index: 30;
  visibility: visible;
  opacity: 1;
  box-shadow: 1px 2px 3px rgb(0 0 0 / 13%);
  background-color: white;
}

.before, .after {
  position: sticky;
  background-color: white;
}

.before {
  top: -3px;
}

.after {
  bottom: 0;
}

.notFromTable.form-control {
  border: 1px solid #bebfc1;
}

.form-control.tableForm {
  min-height: 38px;
}

</style>
